app.service("SelectService", ['$rootScope', function ($rootScope) {

    const siteHelper = $rootScope.site_helper;

    const modelConstructor = $rootScope.model_constructor;

    const SelectModel = modelConstructor.extend(modelConstructor.RouteModel, {
        name: "Select",
        id: "select",
        navigation_pointer: "select_id",
        show_with_children: true
    });

    this.factory = new modelConstructor.RouteFactory({
        birth: function (values) {
            return new SelectModel(values);
        },

        applyModelVariation: applyModelVariation
    });

    function applyModelVariation(model) {

        this.super(model);

        const variationIDs = model.variation_ids;

        const solutionID = variationIDs.solution_id;
        const componentID = variationIDs.component_id;
        const requestRangeID = variationIDs.request_range_id;
        const parentCategoryID = variationIDs.parent_category_id;
        const parentCategoryGroupID = variationIDs.parent_category_group_id;
        const siteRangeID = variationIDs.site_range_id;
        const styleID = variationIDs.style_id;
        const colourID = variationIDs.colour_id;
        const tabID = variationIDs.tab_id;
        const methodProductID = variationIDs.method_product_id;

        let choiceList = null
        let nextModelID = null;


        if (componentID === "solution_cabinet") {
            if (methodProductID !== "matrix") {
                choiceList = $rootScope.service.cache_local_server.getAlphaCategoryChoiceList("solution", parentCategoryGroupID, parentCategoryID, null, null, siteRangeID, colourID, styleID);
            }
            nextModelID = "collection_product";
        } else if (componentID === "select_accessory") {
            let choiceOrder;
            if (requestRangeID === "pronto") {
                choiceOrder = ["pronto_colour_accessory"];
            } else if (solutionID) {
                if (solutionID === "bedroom_flat_pack") {
                    choiceOrder = ["solution_bedroom"];
                } else {
                    choiceOrder = ["general_kitchen_bedroom"];
                }
            } else {
                choiceOrder = ["general", "kitchen", "bedroom"];
            }
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("stock", choiceOrder, null, parentCategoryGroupID, siteRangeID, colourID, styleID);
            nextModelID = "collection_product";
        } else if (componentID === "promotional") {
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("stock", null, null, parentCategoryGroupID, siteRangeID, colourID, styleID);
            nextModelID = "collection_product";
        } else if (componentID === "cabinet_kitchen") {
            const cabinetChoiceOrder = [
                "base",
                "wall",
                "tall_wall",
                "tower",
                "tall_tower",
                "shelving_pack"
            ];
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("cabinet_kitchen", cabinetChoiceOrder);
            const stockChoiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("stock", ["extra"]);
            choiceList = choiceList.concat(stockChoiceList);
            nextModelID = "collection_product";
        } else if (componentID === "cabinet_bedroom") {
            const cabinetChoiceOrder = [
                "wardrobe",
                "chest"
            ];
            choiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("cabinet_bedroom", cabinetChoiceOrder);
            const stockChoiceList = $rootScope.service.cache_local_server.getParentCategoryChoiceList("stock", ["extra"]);
            choiceList = choiceList.concat(stockChoiceList);
            nextModelID = "collection_product";
        }

        const choiceOrder = [];
        const choices = {};
        if (choiceList) {
            for (let i = 0; i < choiceList.length; i++) {
                const choice = choiceList[i];
                choice.state_values.select_name = choice.name;
                choices[choice.id] = choice;
                choiceOrder.push(choice.id);
            }
        }

        model.choice_order = choiceOrder;
        model.choices = choices;
        model.next_model_id = nextModelID;


        siteHelper.applyValues(model, {
            choices: choices,
            choice_order: choiceOrder
        });
    }

}]);